import { deviceTypeToAdZoneDevice } from './getAdZoneKey'

export const zoneNameMatchesDeviceType = (zoneName: string, deviceType: 'mobile' | 'desktop' | 'any' | null) => {
    const deviceTypePrefix = deviceTypeToAdZoneDevice(deviceType)
    if (!deviceTypePrefix) {
        return false
    }
    return zoneName.startsWith(deviceTypePrefix)
}
